import { getToken } from "../../../utils/tokenStorage";

export const VOICE_API_BASE_URL = process.env.REACT_APP_VOICE_API_BASE_URL || "http://127.0.0.1:5000";

const headers = () => {
    const token = getToken();
    if (!token) throw new Error("Connectez-vous pour utiliser Selfcare.");
    return { Authorization: token.startsWith("Bearer ") ? token : `Bearer ${token}` };
};

export async function startAssistantConversation() {
    const response = await fetch(`${VOICE_API_BASE_URL}/assistant/conversations`, { method: "POST", headers: headers() });
    const data = await response.json();
    if (!response.ok) {
        const error = new Error(data.message || "Impossible de commencer la conversation.");
        error.status = response.status;
        throw error;
    }
    return data;
}

export async function sendAssistantMessage(message, conversationId, messageId, files = []) {
    const body = new FormData();
    body.append("message", message);
    body.append("messageId", messageId);
    if (conversationId) body.append("conversationId", conversationId);
    files.forEach(file => body.append("files", file));
    const response = await fetch(`${VOICE_API_BASE_URL}/assistant/messages`, {
        method: "POST", headers: headers(), body,
    });
    const data = await response.json();
    if (!response.ok) {
        const error = new Error(data.message || "L'assistant n'a pas confirmé le traitement.");
        error.status = response.status;
        throw error;
    }
    return data;
}

export async function resumeAssistant(conversationId) {
    const response = await fetch(`${VOICE_API_BASE_URL}/assistant/conversations/${encodeURIComponent(conversationId)}`, { headers: headers() });
    if (!response.ok) throw new Error("Conversation expirée ou session différente. Commencez une nouvelle conversation.");
    return response.json();
}

export async function downloadAssistantDocument(conversationId, documentId) {
    const response = await fetch(`${VOICE_API_BASE_URL}/assistant/conversations/${encodeURIComponent(conversationId)}/documents/${encodeURIComponent(documentId)}`, { headers: headers() });
    if (!response.ok || !response.headers.get("Content-Type")?.includes("application/pdf")) {
        throw new Error("Le document n'est plus disponible ou son accès a été refusé.");
    }
    const url = URL.createObjectURL(await response.blob());
    const link = document.createElement("a");
    link.href = url;
    link.download = "attestation.pdf";
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
}
